import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, of, switchMap } from 'rxjs';
import * as potentialCauseActions from '../actions/potential-cause.actions';
import { PotentialCauseService } from '../../services/potential-cause.service';

@Injectable()
export class PotentialCauseEffects {
  constructor(
    private actions$: Actions,
    private potentialCauseService: PotentialCauseService
  ) {}

  // Load potential causes
  loadPotentialCause$ = createEffect(() =>
    this.actions$.pipe(
      ofType(potentialCauseActions.loadPotentialCause),
      mergeMap(({ ruleUid }) => {
        return this.potentialCauseService.GetByRuleUid(ruleUid).pipe(
          map((potentialCause) => {
            return potentialCauseActions.loadPotentialCauseSuccess({
              potentialCause,
            });
          }),
          catchError((error) => {
            return of(
              potentialCauseActions.loadPotentialCauseFailure({ error })
            );
          })
        );
      })
    )
  );

  // Delete multiple potential causes
  deleteMultiplePotentialCauses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(potentialCauseActions.deleteMultiplePotentialCauses),
      mergeMap(({ uids }) => {
        return this.potentialCauseService
          .DeleteMultiplePotentialCauses(uids)
          .pipe(
            map(() =>
              potentialCauseActions.deleteMultiplePotentialCausesSuccess({
                uids,
              })
            ),
            catchError((error) =>
              of(
                potentialCauseActions.deleteMultiplePotentialCausesFailure({
                  error,
                })
              )
            )
          );
      })
    )
  );

  // Create multiple potential causes
  createMultiplePotentialCauses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(potentialCauseActions.createMultiplePotentialCauses),
      mergeMap(({ requests }) => {
        return this.potentialCauseService
          .CreateMultiplePotentialCauses(requests)
          .pipe(
            map((potentialCauses) =>
              potentialCauseActions.createMultiplePotentialCausesSuccess({
                potentialCauses,
              })
            ),
            catchError((error) =>
              of(
                potentialCauseActions.createMultiplePotentialCausesFailure({
                  error,
                })
              )
            )
          );
      })
    )
  );

  // Update multiple potential causes
  updateMultiplePotentialCauses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(potentialCauseActions.updateMultiplePotentialCauses),
      mergeMap(({ requests }) => {
        return this.potentialCauseService
          .UpdateMultiplePotentialCauses(requests)
          .pipe(
            map((potentialCauses) =>
              potentialCauseActions.updateMultiplePotentialCausesSuccess({
                potentialCauses,
              })
            ),
            catchError((error) =>
              of(
                potentialCauseActions.updateMultiplePotentialCausesFailure({
                  error,
                })
              )
            )
          );
      })
    )
  );
}
